import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { FatturazionePAComponent } from './fatturazione-pa';
import { PAComponiFatturaModule } from './pa-componi-fattura/pa-componi-fattura.module';
import { PAComponiFatturaConfirmModule } from './pa-componi-fattura-confirm/pa-componi-fattura-confirm.module';
import { PAComponiFatturaSummaryModule } from './pa-componi-fattura-summary/pa-componi-fattura-summary.module';
import { PAComponiFatturaSempliceModule } from './pa-componi-fattura-semplice/pa-componi-fattura-semplice.module';
import { PACaricaFatturaModule } from './pa-carica-fattura/pa-carica-fattura.module';
import { PACaricaFatturaSummaryModule } from './pa-carica-fattura-summary/pa-carica-fattura-summary.module';
import { PAVisualizzaStatoFattureModule } from './pa-visualizza-stato-fatture/pa-visualizza-stato-fatture.module';
import { VisualizzaPAFilterModule } from './visualizza-pa-filter/visualizza-pa-filter.module';
import { WorkerCaricaFatturePAModalModule } from './worker-carica-fattura-pa-modal/worker-carica-fattura-pa-modal.module';
import { WorkerComponiFatturaPAConfirmModalModule } from './worker-componi-fattura-pa-confirm-modal/worker-componi-fattura-pa-confirm-modal.module';
import { RiferimentoPAModalModule } from './riferimento-pa-modal/riferimento-pa-modal.module';
import { DettaglioLineePAModalModule } from './dettaglio-linee-pa-modal/dettaglio-linee-pa-modal.module';
import { FatturazioneConfermaModule } from './fatturazione-conferma/fatturazione-conferma.module';
import { SelezionaPAModalModule } from './seleziona-pa-modal/seleziona-pa-modal.module';
import { CigCupModalModule } from './cig-cup-modal/cig-cup-modal.module';
import { RitenutaAccontoPAModalModule } from './ritenuta-acconto-pa-modal/ritenuta-acconto-pa-modal.module';
import { BolloVirtualePAModalModule } from './bollo-virtuale-pa-modal/bollo-virtuale-pa-modal.module';
import { WorkerFatturazioneGeneratePackagePAModalModule } from './worker-fatturazione-generate-package-pa-modal/worker-fatturazione-generate-package-pa-modal.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.fatturazione-pa', {
            url: '/fatturazione-pa',
            ncyBreadcrumb: {
                label: 'Fatturazione PA',
                parent: 'home.fatturazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Fatturazione PA'
            },
            'views': {
                'homeContent': {
                    template: '<fatturazione-pa flex="100"></fatturazione-pa>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const FatturazionePAModule: string = ng
    .module('fatturazione-pa', [
        'ui.bootstrap',
        uiRouter,
        PAComponiFatturaModule,
        PAComponiFatturaConfirmModule,
        PAComponiFatturaSummaryModule,
        PAComponiFatturaSempliceModule,
        PACaricaFatturaModule,
        PACaricaFatturaSummaryModule,
        PAVisualizzaStatoFattureModule,
        VisualizzaPAFilterModule,
        WorkerCaricaFatturePAModalModule,
        WorkerComponiFatturaPAConfirmModalModule,
        RiferimentoPAModalModule,
        DettaglioLineePAModalModule,
        FatturazioneConfermaModule,
        SelezionaPAModalModule,
        CigCupModalModule,
        RitenutaAccontoPAModalModule,
        BolloVirtualePAModalModule,
        WorkerFatturazioneGeneratePackagePAModalModule
    ])
    .component('fatturazionePa', FatturazionePAComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/fatturazione-pa.module.ts